import React, { Fragment } from "react"; 
import { Seo, Breadcrumb, ScrollTopBtn } from "../components";
import { HeaderThree, ServiceSingle, FooterTwo } from "../containers";

const serviceContent = {
  topImage: "/images/service/sr-d-1-1-erp.jpg",
  heading: "ERP & Enterprise Solutions",
  description: `Our ERP & Enterprise Solutions empower businesses to streamline operations, improve efficiency, and gain real-time visibility across all departments. We design and implement scalable ERP systems tailored to your workflows—covering finance, HR, supply chain, inventory, and customer management. With secure integrations and advanced analytics, our solutions support smarter decision-making and long-term growth.`,

  middleImage: "/images/service/sr-d-1-2-erp.jpg",
  features: [
    "Custom ERP System Design & Implementation",
    "Module-Based Development (HR, Finance, Inventory, Supply Chain, etc.)",
    "Data Centralization, Analytics & Reporting",
    "Third-Party Integrations & API Support",
    "Cloud & On-Premise Deployment Options"
  ],

  challengeHeading: "Challenges in ERP & Enterprise Solutions",
  challengeParagraphs: [
    `Implementing ERP solutions requires a deep understanding of organizational workflows and change management. Poor planning can lead to inefficiencies, low adoption, and increased costs.`,
    `Our team follows a structured, collaborative approach—ensuring seamless integration, user-friendly design, and continuous support to maximize adoption and long-term business value.`
  ],

  bottomImages: [
    "/images/service/sr-d-1-3.jpg",
    "/images/service/sr-d-1-4.jpg",
  ],
};

const ERPSolutions = () => (
  <Fragment>
    <Seo
      title="ERP & Enterprise Solutions"
      description="Tech Ayukta delivers ERP & Enterprise Solutions to streamline operations, improve productivity, and provide real-time business insights."
      keywords="ERP Solutions, Enterprise Software, Business Automation, ERP Development, Tech Ayukta"
      canonical="https://www.techayukta.com/services/erp-enterprise-solutions"
    />
    <HeaderThree />
    <Breadcrumb
      pageName="ERP & Enterprise Solutions"
      bgImage="/images/breadcumb/breadcumb-bg.jpg"
    />
    <ServiceSingle
      className="space-top space-extra-bottom"
      serviceContent={serviceContent}
    />
    <FooterTwo />
    <ScrollTopBtn />
  </Fragment>
);

export default ERPSolutions;
